module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"project-title":"Projet","submit-create-label":"Créer","submit-update-label":"Modifier","delete-label":"Supprimer"},"de":{"project-title":"Projekt","submit-create-label":"Erstellen","submit-update-label":"Modifizieren","delete-label":"Löschen"}}')
  delete Component.options._Ctor
}
